import { ArrowDownRight, ArrowUpRight, Info } from "lucide-react";
import type { Metric, MetricName } from "../types";
import { metricLabels } from "../types";
import { metricChange, metricValue } from "../format";
import styles from "../Analytics.module.css";
export default function MetricGrid({
  metrics,
  names,
  compare,
  selected,
  onSelect,
}: {
  metrics: Partial<Record<MetricName, Metric>>;
  names: MetricName[];
  compare: boolean;
  selected?: MetricName;
  onSelect?: (name: MetricName) => void;
}) {
  return (
    <div className={styles.metrics}>
      {names.map((name) => {
        const metric = metrics[name],
          estimated =
            metric?.quality === "approximate" ||
            metric?.provenance === "daily_user_sum";
        const delta = metricChange(metric);
        const positive =
          delta === "New" ||
          (!!metric?.change &&
            (name === "position" ? metric.change < 0 : metric.change > 0));
        const body = (
          <>
            <span className={styles.metricLabel}>
              {estimated && name === "users"
                ? "Estimated active users"
                : metricLabels[name]}
              <span className={styles.metricSource}>
                {["clicks", "impressions", "ctr", "position"].includes(name)
                  ? "GSC"
                  : "GA4"}
              </span>
            </span>
            <strong className={styles.metricValue}>
              {metricValue(metric)}
            </strong>
            {compare && (
              <span
                className={styles.delta}
                data-positive={
                  delta === "Comparison unavailable" ? undefined : positive
                }
              >
                {delta !== "Comparison unavailable" &&
                  delta !== "No change" &&
                  (positive ? (
                    <ArrowUpRight size={15} />
                  ) : (
                    <ArrowDownRight size={15} />
                  ))}
                {delta}
              </span>
            )}
            {estimated && (
              <span className={styles.metricNote}>
                <Info size={12} />
                Daily totals may count a person more than once.
              </span>
            )}
            {metric?.value === null && (
              <span className={styles.metricNote}>
                {metric.reason_code === "source_not_connected"
                  ? "Source not connected"
                  : "No reliable result for this period"}
              </span>
            )}
          </>
        );
        return onSelect ? (
          <button
            key={name}
            className={styles.metric}
            aria-pressed={selected === name}
            onClick={() => onSelect(name)}
          >
            {body}
          </button>
        ) : (
          <div key={name} className={styles.metric}>
            {body}
          </div>
        );
      })}
    </div>
  );
}
